import DOMPurify from "dompurify";
import React from "react";
import classes from './htmlView.module.css'

const HTMLView: React.FC<{
    html: string;
}> = ({ html }) => {
    const sanitized = DOMPurify.sanitize(html);
    return <div className={classes.tableContainer} dangerouslySetInnerHTML={{ __html: sanitized }} />
}

export default HTMLView;